import React, { Component } from 'react';
import { Link } from 'react-router';

export default class VideoGallery extends Component {

	 constructor(props) {
    super(props);
    this.state = {
      width: null,
      height: null
    };
    this.updateSize = this.updateSize.bind(this);
   }

	componentDidMount() {
    window.addEventListener('resize', this.updateSize);
    this.updateSize()
  }

  updateSize() {
		let windowSize = window.innerWidth;
		console.log('update screen width', windowSize)

		let NewWidth = null;

		if (windowSize > 1024) {
			NewWidth = (1024 - 64) / 2;
			
		} else if (windowSize < 1024 && windowSize > 767) {
			NewWidth = (windowSize - 64) / 2;

		} else {
			NewWidth = windowSize - 32;
		}

		let NewHeight = (NewWidth / 16) * 9;
		this.setState({width: NewWidth, height: NewHeight})
  }

  render() {
    const { } = this.props;
    const { width, height } = this.state;

    let videoItems = [
      { "title": "Live at Tractor Tavern - 12/15/22",
        "link": "https://www.youtube.com/embed/D2pGMyVsiec"
      },
      { "title": "Live at Nectar Lounge - 7/21/22",
        "link": "https://www.youtube.com/embed/KmAVXhI4wfw"
      },
      { "title": "Live at The Goodfoot Lounge - 3/10/22",
        "link": "https://www.youtube.com/embed/BVnz1XI6FGE"
      },
      { "title": "Live at Nectar Lounge - 10/31/21",
        "link": "https://www.youtube.com/embed/UpPd2Q5D11o"
      },
      { "title": "Live at The Central Saloon - 11/19/21",
        "link": "https://www.youtube.com/embed/-G2Bt89QIXE"
      },
    	{ "title": "\"The Wave\" Live at the High Dive - 8/7/20",
    		"link": "https://www.youtube.com/embed/WYje8uBJCa8"
	    },
	    // { "title": "Gilded Guilt > Blurry Lovers > Galapagos Live at the High Dive - 08/07/20",
    	// 	"link": "https://www.youtube.com/embed/G8IfbiqnS1w"
	    // },
	    // { "title": "Moose Almighty Livestream to Benefit Racial Equality - 06/18/20",
    	// 	"link": "https://www.youtube.com/embed/-2VLbo827gE"
	    // },
	    // { "title": "The Wave Live at The Central Saloon - 02/01/2020",
    	// 	"link": "https://www.youtube.com/embed/V8VjhGliTFs"
	    // },
	    // { "title": "Moose Almighty Live at The Sunset Tavern - 12/17/2019",
    	// 	"link": "https://www.youtube.com/embed/TpES1i7go3U"
	    // },
	    // { "title": "Moose Almighty Live at The Sunset Tavern - 9/30/19",
    	// 	"link": "https://www.youtube.com/embed/uHe7PpIH9yM"
	    // },

		]
		
		// let height = "315"
		// let width = "560"

    let videos = videoItems.map(video => {
    	return (
    		<div className="gallery__video">
          <iframe className="youtube-embed" width={width} height={height} src={video.link} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    			<p>{video.title}</p>
    		</div>
    	)
    });


    console.log('width', width, height)


    return (
      <div className="VideoGallery">
      	{videos}
      </div>    
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Sections/VideoGallery/VideoGallery.js